import Button from 'components/Button'
import { View } from 'components/View'
import React from 'react'

/**
 * @param style
 * @param onClick
 * @param imageElement
 * @param children
 * @param url
 * @param mt
 * @returns {JSX.Element}
 * @constructor
 */
export function ListRowItemWithImage ({
  style,
  onClick,
  imageElement,
  children,
  mt = '1.3em',
  url
}) {
  return (
    <View style={style}>
      <Button
        onClick={onClick}
        style={{
          width: '100%',
          height: 'unset'
        }}
        height='auto'
        url={url}
      >
        <View
          row
          ac
          mt={mt}
          w
        >
          <View style={{
            minWidth: '80px',
            width: '80px',
            height: '100px'
          }}
          >
            {imageElement}
          </View>

          <View style={{ flex: 1 }}>
            {children}
          </View>
        </View>
      </Button>
    </View>
  )
}
